module.exports = __webpack_public_path__ + "assets/GoodsAll.e458e927.svg";